export default {
  getList: {
    method: 'post',
    url: '/partner/commodity/cooperatorId/list'
  },
  getDetail: {
    method: 'get',
    url: '/partner/commodity/cooperatorId/detail/ID'
  },
  create: {
    method: 'post',
    url: '/partner/commodity/cooperatorId/create'
  },
  update: {
    method: 'put',
    url: '/partner/commodity/cooperatorId/update/ID'
  },
  delete: {
    method: 'delete',
    url: '/partner/commodity/cooperatorId/delete/ID'
  },
  archive: {
    method: 'delete',
    url: '/partner/commodity/archive'
  },
  restore: {
    method: 'put',
    url: '/partner/commodity/restore'
  }
}
